<template>
  <div class="container-fluid page">

    <div class="row mt-4 flex-grow-1">
      <!-- Retailer List START -->
      <div class="col-3">
        <card class="h-100">
          <h2 class="branch-management-heading">Branch Management</h2>
          <div class="retailers">
            <div class="retailer" :class="selectedRetailer && selectedRetailer.id === r.id ? 'active' : null" v-for="r in retailers" :key=r.id @click="selectRetailer(r)">
              <location-icon class="logo" :logo="r.logoUrl"></location-icon>
              <p class="description">
                {{ r.name }}<br>
                {{ r.address_line_1 }}
              </p>
            </div>
          </div>
        </card>
      </div>
      <!-- // Retailer List END -->

      <div class="col-9 d-flex flex-column">
        <div class="row">
          <div class="col-12">
            <!-- Rota -->
            <retailer-rota-card v-if="selectedRetailer" cardTitle="Rota" :retailer="selectedRetailer" @retailerUpdated="updateRetailer"></retailer-rota-card>
          </div>
        </div>
        <div class="row mt-4 flex-grow-1">
          <div class="col-12">
            <!-- Past Drops -->
            <retailer-past-drops-card v-if="selectedRetailer" :drops="pastDrops" :usePagination="true" :resultsPerPage="5" :showReportIssueButton="false" @updated="updatePastDrops"></retailer-past-drops-card>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>
<script>
  // Imports
  import UserStore from '../../../services/UserStore';
  import RetailerLeadsService from '../../../services/RetailerLeadsService';
  import RetailersService from '../../../services/RetailersService';
  import RetailerRotaCard from '@/components/Cards/RetailerRotaCard';
  import RetailerPastDropsCard from '@/components/Cards/RetailerPastDropsCard';
  import LocationIcon from '@/components/LocationIcon';

  export default {
    name: 'retailer-lead-branch-management',

    components: {
      RetailerRotaCard,
      RetailerPastDropsCard,
      LocationIcon
    },

    data() {
      return {
        retailers: [],
        selectedRetailer: null,
        pastDrops: []
      };
    },
    
    created() {
      this.init();
    },

    methods:{
      async init() {
        try {
          let retailersRes = await RetailerLeadsService.getOwnRetailers();
          this.retailers = retailersRes.data;
        }
        catch(err) {
          console.log('Error fetching retailers', err);
          alert('Whoops! Something went wrong, the page may not have loaded correctly. Please try again.');
        }
      },

      async selectRetailer(retailer) {
        try {
          let pastDropsRes = await RetailersService.getPastDrops(retailer.id);
          this.pastDrops = pastDropsRes.data;
        }
        catch(err) {
          console.log('Error fetching past drops', err);
          alert('Whoops! Something went wrong, the page may not have loaded correctly. Please try again.');
        }

        this.selectedRetailer = retailer;
      },

      async updateRetailer() {
        // let result = await RetailersService.getById(this.selectedRetailer.id);
        // this.selectedRetailer = result.data;
        try {
          let retailersRes = await RetailerLeadsService.getOwnRetailers();
          this.retailers = retailersRes.data;
  
          this.selectedRetailer = this.retailers.find.find((r) => {
            r.id = this.selectedRetailer.id
          });
        }
        catch(err) {
          console.log('Error fetching updated retailer', {err});
        }
      },

      async updatePastDrops() {
        try {
          let pastDropsRes = await RetailersService.getPastDrops(this.selectedRetailer.id);
          this.pastDrops = pastDropsRes.data;
        }
        catch(err) {
          console.log('Error fetching past drops', err);
          alert('Whoops! Something went wrong, the page may not have loaded correctly. Please try again.');
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
    .page {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 10rem);
  }

  .branch-management-heading {
    margin-bottom: 0;
  }

  .retailers {
    margin-top: 6.25rem;

    .retailer {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-items: center;
      padding: 1.25rem;
      transition: background-color 250ms ease;
      border-bottom: 1px solid #E5EAF3;
      cursor: pointer;

      &.active {
        background-color: #EFF0F6;
        border-left: 0.375rem solid #F95940;
        padding-left: (1.25rem - 0.375rem)
      }

      .logo {
        width: 2.8125rem;
        border-radius: 50%;
        margin-right: 0.75rem;
      }

      .description {
        margin: 0;
        padding: 0;
        font-size: 0.9573rem;
        line-height: 1.125rem;
      }
    }
  }
</style>
